export const PermissionRegistry = {
  InternalAdmin: {
    // Role Management
    AdminRoleRead: 'admin.role.read',
    AdminRoleCreate: 'admin.role.create',
    AdminRoleUpdate: 'admin.role.update',
    AdminRoleDelete: 'admin.role.delete',

    // Customer Management
    AdminCustomerRead: 'admin.customer.read',
    AdminCustomerCreate: 'admin.customer.create',
    AdminCustomerUpdate: 'admin.customer.update',
    AdminCustomerDelete: 'admin.customer.delete',

    // User Management
    AdminUserRead: 'admin.user.read',
    AdminUserCreate: 'admin.user.create',
    AdminUserUpdate: 'admin.user.update',
    AdminUserDelete: 'admin.user.delete',

    // Reports
    AdminReportRead: 'admin.report.read',
    // License
    LicenseRead: 'license.read',
    LicenseCreate: 'license.create',
    LicenseUpdate: 'license.update',
    LicenseDelete: 'license.delete',

    // External connection settings admin area (#9731)
    SettingsExternalRead: 'admin.settings.external.read',
    SettingsExternalManage: 'admin.settings.external.manage',
  },

  CustomerAdmin: {
    CustomerUserRead: 'customer.user.read',
    CustomerUserCreate: 'customer.user.create',
    CustomerUserUpdate: 'customer.user.update',
    CustomerUserDelete: 'customer.user.delete',

    CustomerAdminRead: 'customer.admin.read',
    CustomerAdminCreate: 'customer.admin.create',
    CustomerAdminUpdate: 'customer.admin.update',
    CustomerAdminDelete: 'customer.admin.delete',
  },

  User: {
    UserSelfRead: 'user.self.read',
    UserSelfCreate: 'user.self.create',
    UserSelfUpdate: 'user.self.update',
    UserSelfDelete: 'user.self.delete',
  },
} as const;

export const RolesRegistry = {
  InternalAdmin: 'admin',
  CustomerAdmin: 'customeradmin',
  User: 'user',
} as const;
